module.exports = __webpack_public_path__ + "img/2022-03.39332956.jpg";